import "@vintecc/components/style.css";
import { createRoot } from "react-dom/client";
import "./index.css";
import { StrictMode } from "react";
import App from "./App";
import ENV from "./env";
import { preloadInitialCulture } from "./services/culture/bootstrap";

const rootEl = document.getElementById("root")!;

// Auth shows no version on screen, so the release tag sits on the root element for anyone checking a deploy.
if (ENV.VERSION) rootEl.dataset.appVersion = ENV.VERSION;

const bootstrap = async () => {
  const initialCulture = await preloadInitialCulture();

  createRoot(rootEl).render(
    <StrictMode>
      <App initialCulture={initialCulture} />
    </StrictMode>,
  );
};

void bootstrap();
